import {scrollToWithDuration} from '../utils/scroll-to';

const initAbout = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-scroll-btn]');

    if (btn) {
      e.preventDefault();
      const target = document.querySelector(btn.getAttribute('href'));

      if (target) {
        const y = target.getBoundingClientRect().top + window.pageYOffset - Math.max(((window.innerHeight - target.offsetHeight) / 2), 120);

        scrollToWithDuration(y, 1000);
      }
    }

    const selectItem = e.target.closest('.custom-select__item');

    if (selectItem && selectItem.closest('[data-select-menu]')) {
      const menu = document.querySelector('.main-nav');
      const header = document.querySelector('.header');

      if (menu) {
        menu.classList.remove('is-menu-show');

        if (header) {
          header.classList.remove('header--white');
        }

        window.scrollLock.enableScrolling();
      }

      if (selectItem.closest('.main-nav')) {
        setTimeout(() => {
          window.barba.go(`${selectItem.dataset.selectValue}.html`);
        }, 1000);
      } else {
        window.barba.go(`${selectItem.dataset.selectValue}.html`);
      }
    }
  });
};

export {initAbout};
